
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ValidationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  errors: string[];
}

const ValidationDialog = ({ open, onOpenChange, errors }: ValidationDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Ebaturvaline parool</AlertDialogTitle>
          <AlertDialogDescription>
            <div className="space-y-2">
              <p>Sinu valitud parool ei vasta turvalisuse nõuetele:</p>
              <ul className="list-disc list-inside mt-1 ml-1">
                {errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
              <p className="mt-2">Palun vali tugevam parool.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex justify-end">
          <Button 
            onClick={() => onOpenChange(false)}
          >
            Mõistan
          </Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ValidationDialog;
